<div class="container-idle">
	<div class="modal" tabindex="-1">
		<div class="modal-dialog">
			<div class="modal-content">
				<div class="modal-header">
					<h1>Crea una Ubicación</h1>
					<h1 style="left: 0;" class="i-hover"><i class="fa fa-xmark" (click)="close.emit(false)"></i></h1>
				</div>
				<div class="modal-body">
					<div class="form-group">
						<label for="name" class="form-label">Nombre de la Ubicación<span
							class="required">*</span></label>
						<input type="text" placeholder="Ingresa el nombre de la ubicación" name="name"
							id="name" [(ngModel)]="nameLocation" class="form-control">
					</div>
					<div class="form-group">
						<label for="address" class="form-label">Dirección de la Ubicación<span
							class="required">*</span></label>
						<input type="text" placeholder="Ingresa la dirección de la ubicación" name="address"
							id="address" [(ngModel)]="addressLocation" class="form-control">
					</div>
					<p class="text-muted" style="margin-top: 1em; font-size: 0.8em; text-align: right;"><i
							class="fa fa-circle-info"></i>Completa los campos marcados con un <span
							class="required">*</span> para guardar la ubicación </p>
				</div>
				<div class="modal-footer">
					<button class="btn btn-success"
						[disabled]="!nameLocation || !addressLocation || loading"
						(click)="addLocation()">
						<ng-container *ngIf="!loading">
							<i class="fa fa-floppy-disk"></i>
						</ng-container>
						<ng-container *ngIf="loading">
							<span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
							<span role="status"></span>
						</ng-container>GUARDAR
					</button>
				</div>
			</div>
		</div>
	</div>
</div>